import { Inline } from 'braid-design-system';
import React from 'react';

import { PriceWithCurrencyText } from 'src/app/views/components/PriceWithCurrencyText';
import { TaxSuffix } from 'src/app/views/components/TaxSuffix';
import { useConfig } from 'src/app/views/hooks/useConfig';
import type { Currency, Tax } from 'src/graphql/generated';

import { getPriceWithTax } from './utils/getPriceWithTax';

interface CurrencyTextProps {
  displayTaxSuffix?: boolean;
  tax?: Tax;
  originalPrice: number;
  currency: Currency;
  size?: 'standard' | 'xsmall';
  priceWeight?: 'regular' | 'medium' | 'strong';
  taxWeight?: 'regular' | 'medium' | 'strong';
  tone?: 'neutral' | 'secondary';
}

export const PriceCurrencyTax = ({
  tax,
  originalPrice,
  currency,
  size = 'standard',
  priceWeight = 'regular',
  taxWeight = 'regular',
  tone = 'secondary',
  displayTaxSuffix = true,
}: CurrencyTextProps) => {
  const { getLocale } = useConfig();

  const hasTax =
    tax && Boolean(tax.code && tax.displayRecommendation && displayTaxSuffix);

  const price = getPriceWithTax(originalPrice, tax);
  return (
    <Inline space={'xxsmall'} align={'right'} alignY={'center'}>
      <PriceWithCurrencyText
        size={size}
        weight={priceWeight}
        value={price}
        currency={currency}
      />
      {hasTax ? (
        <>
          <TaxSuffix
            taxCode={tax.code!}
            displayRecommendation={tax.displayRecommendation!}
            locale={getLocale()}
            size={size}
            weight={taxWeight}
            tone={tone}
          />
        </>
      ) : null}
    </Inline>
  );
};
